import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { MapContainer, TileLayer, useMapEvents, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import LocationMarker from "./LocationMarker";
import { MAP_TILES } from "configurations/Constants";
import {
  FULL_SCREEN,
  STREET_VIEW,
  LABEL_VIEW,
} from "configurations/MessageConstants";

const MapClickHandler = ({ onMapClick }) => {
  useMapEvents({
    click: (e) => {
      onMapClick(e.latlng);
    },
  });
  return null;
};

const InvalidateMapSize = ({ isFullScreen }) => {
  const map = useMap();
  useEffect(() => {
    map.invalidateSize();
  }, [isFullScreen, map]);
  return null;
};

const RegistrationMap = ({ geometry, handleMapClick }) => {
  const [streetView, setStreetView] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [showLabel, setShowLabel] = useState(true);
  return (
    <div className={`${isFullScreen ? "map-container-full" : "map-container"}`}>
      <MapContainer
        center={[33.5778, -101.8553]}
        zoom={11}
        minZoom={2}
        style={{ height: "100%", width: "100%" }}
      >
        {streetView ? (
          <TileLayer
            url={MAP_TILES.STREET_VIEW.url}
            attribution={MAP_TILES.STREET_VIEW.attribution}
          />
        ) : (
          <TileLayer
            url={
              showLabel
                ? MAP_TILES.SATELLITE_WITH_LABELS.url
                : MAP_TILES.SATELLITE_WITHOUT_LABELS.url
            }
            attribution={
              showLabel
                ? MAP_TILES.SATELLITE_WITH_LABELS.attribution
                : MAP_TILES.SATELLITE_WITHOUT_LABELS.attribution
            }
          />
        )}

        <MapClickHandler onMapClick={handleMapClick} />
        {geometry && <LocationMarker position={geometry} />}
        <InvalidateMapSize isFullScreen={isFullScreen} />
      </MapContainer>

      <div className="map-controls d-flex flex-column">
        <Button
          variant={"light"}
          onClick={() => setIsFullScreen(!isFullScreen)}
          className={`map-expand-btn ${isFullScreen ? "active-view" : ""}`}
          title={FULL_SCREEN}
        >
          {isFullScreen ? (
            <i className="fa-solid fa-compress" />
          ) : (
            <i className="fa-solid fa-expand" />
          )}
        </Button>
        <Button
          variant={"light"}
          onClick={() => setStreetView(!streetView)}
          className={`map-expand-btn ${streetView ? "street-active-view" : ""}`}
          title={STREET_VIEW}
        >
          <i className="fa-solid fa-street-view" />
        </Button>
        {!streetView && (
          <Button
            variant={"light"}
            onClick={() => setShowLabel(!showLabel)}
            className={`map-expand-btn ${showLabel ? "label-active-view" : ""}`}
            title={LABEL_VIEW}
          >
            <i className="fa-solid fa-tags" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default RegistrationMap;
